var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    loanTypesAvailable,
    loanTypesSelected
  } = options;

__p+='\n\n';
 for(var i=0; i<loanTypesAvailable.length; i++) { 
__p+='\n  <div class="checkbox checkbox-primary">\n    <input type="checkbox"\n           id="loan-type-'+
((__t=( loanTypesAvailable[i]['value'] ))==null?'':__t)+
'"\n           name="loan-type-'+
((__t=( loanTypesAvailable[i]['value'] ))==null?'':__t)+
'"\n           value="'+
((__t=( loanTypesAvailable[i]['value'] ))==null?'':__t)+
'"\n           '+
((__t=( loanTypesSelected.indexOf(loanTypesAvailable[i]['value']) > -1 ? 'checked' : null ))==null?'':__t)+
'\n           />\n    <label for="loan-type-'+
((__t=( loanTypesAvailable[i]['value'] ))==null?'':__t)+
'">\n      '+
((__t=( loanTypesAvailable[i]['label'] ))==null?'':__t)+
'\n    </label>\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_loan_type_checkboxes.jst.ejs